/**
 * @enum {string}
 * @deprecated
 */
export const WORKBOOK_ERROR_KEYS = {
  NO_SPACE_FOR_VIEW_IN_WORKSHEET_GRID: 'no-space-for-view-in-worksheet-grid',
} as const;

/**
 * @see net/disy/cadenza/workbook/web/rest/WorkbookExceptionHandler.java
 * @see https://conf.disy.net/display/DEV/REST+API+Endpoints+in+Cadenza+Web#RESTAPIEndpointsinCadenzaWeb-HttpException (it's the `type` string)
 */
export type WORKBOOK_ERROR_KEYS = (typeof WORKBOOK_ERROR_KEYS)[keyof typeof WORKBOOK_ERROR_KEYS];
